import { render, staticRenderFns } from "./SelfAwareItem.vue?vue&type=template&id=4ba9fb5c&scoped=true&lang=pug&"
import script from "./SelfAwareItem.vue?vue&type=script&lang=js&"
export * from "./SelfAwareItem.vue?vue&type=script&lang=js&"
import style0 from "./SelfAwareItem.vue?vue&type=style&index=0&id=4ba9fb5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba9fb5c",
  null
  
)

export default component.exports